import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackShareWishListParameters extends TrackEventBaseParameters<"item_list_id"> {}

const trackShareWishList = (parameters: TrackShareWishListParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "share_wishlist", ...parameters }, options);
};

export default trackShareWishList;
